export var FrequencyType;
(function (FrequencyType) {
    FrequencyType["MONTHLY"] = "monthly";
    FrequencyType["BIANNUAL"] = "biannual";
    FrequencyType["ANNUAL"] = "annual";
})(FrequencyType || (FrequencyType = {}));
